import { render } from "./decorateStrategy.vue?vue&type=template&id=2bda1f62&scoped=true"
import script from "./decorateStrategy.vue?vue&type=script&lang=js"
export * from "./decorateStrategy.vue?vue&type=script&lang=js"

import "./decorateStrategy.vue?vue&type=style&index=0&id=2bda1f62&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bda1f62"]])

export default __exports__